import { instantDependenciesFactory } from "./dependencies.factory";

export const instantEpicDependencies = {
    instantService: instantDependenciesFactory.getInstantService()
}
